module.exports = __webpack_public_path__ + "static/media/ste_wor_fal_and_arr.434cf6b6.png";